import { render, staticRenderFns } from "./ApoioTopico.vue?vue&type=template&id=71c0a42f&scoped=true"
import script from "./ApoioTopico.vue?vue&type=script&lang=js"
export * from "./ApoioTopico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c0a42f",
  null
  
)

export default component.exports